import { render, staticRenderFns } from "./multiplicityform.vue?vue&type=template&id=c5904a16&"
import script from "./../ts/multiplicityform.ts?vue&type=script&lang=js&"
export * from "./../ts/multiplicityform.ts?vue&type=script&lang=js&"
import style0 from "./../assets/css/multiplicityform.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports